<template>
    <el-dialog title="附件查看" :visible.sync="dialogVisible"
               append-to-body  v-dialogDrag
               width="1000px" :close-on-click-modal="false" @close="close">
        <div class="fileupload">
            <el-table
                    ref="table"
                    :data="dataList"
                    height="450"
                    style="width: 100%;overflow-y: scroll"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    border>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="fileTrueName"
                        label="文件名">
                </el-table-column>
                <el-table-column
                        prop="fileSize"
                        label="文件大小"
                        width="200">
                    <template slot-scope="scope">
                        <div>{{getKb(scope.row.fileSize)}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="uploadBy"
                        label="上传人"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="uploadDate"
                        label="上传时间"
                        width="200">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200">
                    <template slot-scope="scope">
                        <template>
                            <el-button @click="download(scope.row)" type="primary" icon="el-icon-download"
                                       size="medium"></el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>


        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "fileupload",
        props: ['fileParam', "fileListUrl"],
        data() {
            return {
                dialogVisible: true,
                dialoading: false,
                dataList: [],
                fileList: [],
                state: "ready",
            }
        },
        async created() {
            await this.getFileList();
        },
        methods: {
            async getFileList() {
                this.dialoading = true;
                let param = {
                    url: this.fileListUrl,
                    param: {
                        ...this.fileParam
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                this.dialoading = false;
                if (data.infoCode === '0') {
                    this.dataList = data.data.data;
                }
            },
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog')
            },
            download(row) {
                window.open(window.host.ProjectUrl + "/" + row.fileUrl + "/" + row.fileName, '_blank')
            },
            getKb(val) {
                if (val)
                    return (val / 1024).toFixed(2) + "KB"
            },
        },
    }
</script>

<style scoped>
    .fileupload /deep/ .el-table .el-table__cell {
        padding: 5px 0;
    }

    .fileupload /deep/ .el-table__body tr.current-row > td.el-table__cell {
        background-color: #66c4f6;
    }
</style>
